import { render, staticRenderFns } from "./bindProduct.vue?vue&type=template&id=5c34e21e&scoped=true"
import script from "./bindProduct.vue?vue&type=script&lang=js"
export * from "./bindProduct.vue?vue&type=script&lang=js"
import style0 from "./bindProduct.vue?vue&type=style&index=0&id=5c34e21e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c34e21e",
  null
  
)

export default component.exports